import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

type Command = Omit<Database['public']['Tables']['events']['Update'], 'id'>;

async function putEvent(id: string, command: Command) {
  const { data, error } = await apiClient
    .from('events')
    .update(command)
    .eq('id', id)
    .select('id')
    .single();

  if (error) {
    throw error
  }

  return data;
}

export function usePutEvent() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (variables: { id: string, command: Command, subTopicId: string }) => putEvent(variables.id, variables.command),
    onSuccess: () => {
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.upcoming(currentSpace.id) });
      }
    },
  })
}
